import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';
export interface NotifySuccessCommandProperties extends CommandProperties {
	message: string;
	requestUrl: string;
	action: string;
}
export const NotifySuccessCommand = createCommand<NotifySuccessCommandProperties, void>(
	'notify-success-command',
);
